var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_vm._m(0),_c('img',{attrs:{"src":_vm.P777}}),_c('span')])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"process"},[_c('div',{staticClass:"processValue"})])
}]

export { render, staticRenderFns }